import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import AccuracyLevel from '@/entities/enums/Accuracy';
import { useShellTranslation } from '@/hooks/useShellTranslation/useShellTranslation';
const accuracyPoints = (accuracy) => {
    const points = [];
    for (let i = 1; i <= 5; i++) {
        const fillAccuracyPoint = i <= accuracy;
        points.push(_jsx(Box, { as: "span", display: "block", width: "6px", height: "6px", borderRadius: "radius.rounded", backgroundColor: fillAccuracyPoint
                ? 'color.border.active.default'
                : 'color.border.constant.white', borderWidth: fillAccuracyPoint ? 'borderWidth.none' : 'borderWidth.1', borderColor: fillAccuracyPoint ? 'color.border.disabled' : 'color.border.light.default', borderStyle: fillAccuracyPoint ? 'none' : 'solid' }, `accuracy-${i}`));
    }
    return points;
};
export const Accuracy = ({ accuracy }) => {
    const { t } = useShellTranslation();
    return (_jsxs(Box, { display: "flex", flexDirection: "row", typography: "typography.body.12.regular", alignItems: "center", gap: "spacing.6", children: [_jsx(Box, { as: "span", display: "flex", gap: "spacing.2", children: accuracyPoints(accuracy) }), t(`price_block.info_view.accuracy.${AccuracyLevel[accuracy - 1]}`)] }));
};
